<template>
    <div>
        <sub-menu-faturamento ativo="autorizar-cancelamentos"></sub-menu-faturamento>

        <p>Autorizar Cancelamento</p>
    </div>
</template>

<script>
import SubMenuFaturamento from './SubMenuFaturamento.vue';

export default {
    data () { 
        return { 

        }
    },

    components: { 
        SubMenuFaturamento,
    }    
}
</script>